import React, {useContext} from 'react'
import BarGraph from "components/molecules/Graphs/Bar";
import {I18nContext} from "utils/i18n/locale";
import {LEGEND_DIRECTION, LEGEND_POSITION} from "components/molecules/Graphs";
import PieGraph, {TYPE} from "components/molecules/Graphs/Pie";

const ApprovedOrRejected = () => {
	const {translate} = useContext(I18nContext);

	// This should be replaced with an API Call
	const DATA = [
		{
			"id": "approved",
			"label": 'Approved',
			"value": 100,
			"color": "#00B999"
		},
		{
			"id": "rejected",
			"label": 'Rejected',
			"value": 0,
			"color": "#C43A5A"
		}
	]

	return (
		<PieGraph
			height="100%"
			type={TYPE.FULL}
			legendDirection={LEGEND_DIRECTION.ROW}
			legendPosition={LEGEND_POSITION.BOTTOM}
			reverse={true}
			title={translate("pages").analytic.editor.sidePane.menu.approvedOrRejected}
			data={DATA} />
	)
}

export default ApprovedOrRejected;
